import { render } from "./VerificationForm.vue?vue&type=template&id=33d8c834&scoped=true"
import script from "./VerificationForm.vue?vue&type=script&lang=js"
export * from "./VerificationForm.vue?vue&type=script&lang=js"

import "./VerificationForm.vue?vue&type=style&index=0&id=33d8c834&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33d8c834"

export default script